import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";
import CTABlock from "../components/CTABlock";
import { SEO_META, INDUSTRIES } from "../config/site";

export default function Industries() {
  const meta = SEO_META.industries;
  return (
    <>
      <SEO title={meta.title} description={meta.description} path={meta.path} />
      <section className="border-b border-obsidian/10 bg-bone" data-testid="industries-hero">
        <div className="container-site py-16 lg:py-24">
          <Reveal>
            <p className="eyebrow">Industries</p>
            <h1 className="mt-4 max-w-3xl font-display text-4xl font-black leading-[1.06] tracking-tight sm:text-5xl">
              Different roles. One professional identity.
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-obsidian/60">
              Purpose-built workwear for industries where appearance, comfort and performance matter — from
              hospital wards to airport ramps, hotel floors to warehouse docks.
            </p>
            <Link to="/bulk-quote" data-event="bulk_quote_click" data-testid="industries-hero-quote-btn" className="btn-primary mt-8">
              Get Bulk Quote <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="container-site py-16 lg:py-24" data-testid="industries-grid">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.slug} delay={(i % 3) * 0.08}>
              <Link to="/uniforms" data-testid={`industries-card-${ind.slug}`} className="group relative block overflow-hidden bg-obsidian">
                <img
                  src={ind.img}
                  alt={ind.alt}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover opacity-90 transition-all duration-700 ease-out group-hover:scale-[1.06] group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian/90 via-obsidian/15 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-6">
                  <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="mt-1 font-display text-xl font-bold leading-tight text-white">{ind.name}</h2>
                  <p className="mt-1.5 text-xs leading-relaxed text-white/65">{ind.line}</p>
                  <span className="mt-3 inline-flex items-center gap-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-white/80 transition-colors group-hover:text-cleef">
                    View Collection <ArrowRight className="h-3 w-3 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABlock />
    </>
  );
}
